export default {
  COMMENT: 'COMMENT',
  COMPLETION: 'COMPLETION',
  FORECAST: 'FORECAST',
  LOGBOOK: 'LOGBOOK',
  REMARK: 'REMARK',
}
